import axios from 'axios';

export function submitAdvertiserInquiry(payload) {
    return axios.post(`${process.env.REACT_APP_API_URL}/advertiser/inquiry`, payload);
}
